/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import {MsalBroadcastService, MsalService} from "@azure/msal-angular";
import {filter} from "rxjs/operators";
import {EventMessage, EventType} from "@azure/msal-browser";
import { GlobalService } from "@services/global.service";

@Component({
  selector: "ngx-app",
  template: "<router-outlet *ngIf='!isIframe'></router-outlet>",
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  public isIframe: boolean
  public loginDisplay: boolean
  

  constructor(private authService: MsalService, private msalBroadcastService: MsalBroadcastService, private globals: GlobalService) {

  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener

    /*
    this.msalBroadcastService.msalSubject$
        .pipe(
            filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        )
        .subscribe((result: EventMessage) => {
          this.setLoginDisplay()
        });
    */

    this.msalBroadcastService.msalSubject$
        .pipe(
            filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
        )
        .subscribe((result: EventMessage) => {
          this.setLogonData(result)
        });

    // this.login()
  }

  setLogonData(msg) {

    this.globals.account = msg?.payload?.account

  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
